import { FC } from "react";
import { useRecoilState } from "recoil";
import myInfoState from "../../atoms/myinfo";
import roomDetailState from "../../atoms/roomDetail";
import emitDestroyRoom from "../../connector/emits/destroyRoom";
import "./RoomHeader.scoped.scss";

interface RoomHeaderProps {
  ownerNickname: string;
  participants: number;
  thumbnailUrl: string;
  roomName: string;
}

const RoomHeader: FC<RoomHeaderProps> = ({
  ownerNickname,
  participants,
  thumbnailUrl,
  roomName,
}) => {
  const [myInfo] = useRecoilState(myInfoState);
  const [roomDetail] = useRecoilState(roomDetailState);

  const leaveRoom = () => {
    if (myInfo.id === roomDetail.owner) {
      if (window.confirm('방을 삭제하시겠습니까?\n취소를 클릭하면 방 개설을 유지하고 나갑니다.')) {
        emitDestroyRoom();
      } else {
        window.location.href = '/chatting-app/waiting-room';
      }
    } else {
      window.location.href = '/chatting-app/waiting-room';
    }
  }

  return (
    <div className="room-header">
      <div className="room-header__thumbnail">
        <img src={thumbnailUrl} alt="" />
      </div>
      <div>
        <div className="room-header__title">
{/*          <div>
            <b>전체: 10승 0패 / 10연승</b>
          </div>*/}
          <div>
            {roomName}
          </div>
        </div>
        <div className="room-header__information">
          <div>
            <div className="room-header__owner">
              방장 <b>{ownerNickname}</b>
            </div>
{/*            <div className="room-header__time">
              52분전
            </div>*/}
            <div className="room-header__participants">
              접속자 <b>{participants}</b>명
            </div>
{/*            <div className="room-header__participants">
              추천수 <b>{'60'}</b>
            </div>*/}
{/*            <div className="room-header__participants">
              누적 총알수 <b>{'1,250'}</b>
            </div>*/}
          </div>
          <div className="room-header__leave-room">
            <button onClick={leaveRoom}>채팅방 나가기</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RoomHeader;
